import PropTypes from 'prop-types';

export default PropTypes.shape({
  code: PropTypes.string,
  name: PropTypes.string,
  passengerId: PropTypes.string,
  price: PropTypes.number,
  tariffCode: PropTypes.string
});
